var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer post-overlay"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.textContent)}}),(_vm.showLoader)?_c('loaderSVG'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }